
import { Component, Vue, Prop } from 'vue-property-decorator'
import { DriverClient, CompanyClient } from '@/api'
import { ICompanyData } from '@/api/types'
import _ from 'lodash'
import BaseEditor from '@/views/BaseEditor'
import FileUpload from 'vue-upload-component'
import request from '@/utils/request'

@Component({
  name: 'DriverEditor',
  components: {
    FileUpload
  }
})
export default class extends BaseEditor {
  private nations= [
    '汉族',
    '蒙古族',
    '回族',
    '藏族',
    '维吾尔族',
    '苗族',
    '彝族',
    '壮族',
    '布依族',
    '朝鲜族',
    '满族',
    '侗族',
    '瑶族',
    '白族',
    '土家族',
    '哈尼族',
    '哈萨克族',
    '傣族',
    '黎族',
    '傈僳族',
    '佤族',
    '畲族',
    '高山族',
    '拉祜族',
    '水族',
    '东乡族',
    '纳西族',
    '景颇族',
    '柯尔克孜族',
    '土族',
    '达斡尔族',
    '仫佬族',
    '羌族',
    '布朗族',
    '撒拉族',
    '毛南族',
    '仡佬族',
    '锡伯族',
    '阿昌族',
    '普米族',
    '塔吉克族',
    '怒族',
    '乌孜别克族',
    '俄罗斯族',
    '鄂温克族',
    '德昂族',
    '保安族',
    '裕固族',
    '京族',
    '塔塔尔族',
    '独龙族',
    '鄂伦春族',
    '赫哲族',
    '门巴族',
    '珞巴族',
    '基诺族']
  private companyList: ICompanyData[] = [];
  private companyClient = new CompanyClient();
  public constructor() {
    super()
    this.client = new DriverClient()
    this.data = {
      companyId: '',
      name: '',
      sex: '',
      plate_number: '',
      nation: '',
      birthday: '',
      home_address: '',
      id_card_number: '',
      id_card_scanning_copy: '',
      mobile_phone_number: '',
      state: 'Normal'
    }
    this.rules = {
      name: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
      sex: [{ required: true, message: '性别不能为空', trigger: 'blur' }],
      plate_number: [{ required: true, message: '车牌号不能为空', trigger: 'blur' }],
      id_card_number: [{ required: true, message: '身份证号码不能为空', trigger: 'blur' }],
      mobile_phone_number: [{ required: true, message: '手机号码不能为空', trigger: 'blur' }]
    }
  }

  public async getData(id = -1) {
    await super.getData(id)
    await this.getCompanyList()
  }

  private async getCompanyList() {
    this.companyList = await this.companyClient.fetch({
      filter: {
        where: { isDeleted: false },
        fields: {
          id: true,
          name: true,
          nickName: true
        },
        order: ['name']
      }
    })
  }

  public async reset() {
    this.data = {
      companyId: '',
      name: '',
      sex: '',
      plate_number: '',
      id_card_number: '',
      mobile_phone_number: '',
      state: 'Normal',
      nation: '',
      birthday: '',
      home_address: '',
      id_card_scanning_copy: ''
    }
  }

  protected generateData(): any {
    const data = _.pick(this.data, [
      'companyId',
      'name',
      'sex',
      'plate_number',
      'nation',
      'birthday',
      'home_address',
      'id_card_number',
      'id_card_scanning_copy',
      'mobile_phone_number',
      'state'
    ])
    return this.clearData(data)
  }
}
